export const navItems = [
  { label: "Uvod", path: "/" },
  { label: "Sluzby", path: "/sluzby" },
  { label: "Cenik", path: "/cenik" },
  { label: "Realizace", path: "/realizace" },
  { label: "Kontakt", path: "/kontakt" },
];

export const services = [
  {
    title: "Elektroinstalace domu a bytu",
    description: "Nove rozvody, zasuvky, osvetleni, rozvadece a priprava pro revizi.",
    price: "od 45 000 Kc",
  },
  {
    title: "Rekonstrukce elektroinstalace",
    description: "Vymena starych rozvodu, uprava okruhu a sladeni s novymi spotrebici.",
    price: "od 28 000 Kc",
  },
  {
    title: "Revize a servis",
    description: "Revizni zpravy, odstraneni zavad, kontrola bezpecnosti a rychle opravy.",
    price: "od 2 500 Kc",
  },
  {
    title: "Datove rozvody",
    description: "UTP kabelaz, rack, Wi-Fi body, pripojeni TV a priprava chytre domacnosti.",
    price: "od 300 Kc / bod",
  },
];

export const pricing = [
  ["Hodinova sazba", "500 - 700 Kc / hod"],
  ["Vyjezd", "8 Kc / km"],
  ["Instalace zasuvky", "od 600 Kc"],
  ["Vymena jistice", "od 800 Kc"],
  ["Montaz rozvadece", "od 3 500 Kc"],
  ["Revize elektroinstalace", "od 2 500 Kc"],
  ["Datovy bod UTP", "od 300 Kc"],
];

export const realizations = [
  {
    title: "Rekonstrukce bytu 2+1",
    place: "Karlovy Vary",
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Rozvadec v rodinnem dome",
    place: "Loket",
    image:
      "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=900&q=80",
  },
  {
    title: "Venkovni osvetleni",
    place: "Hroznetin",
    image:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=80",
  },
];
